import React from 'react'
import { useTranslation } from 'react-i18next'

import { Typography } from '@/components/ui/typography'
import { ChecklistInput, ChecklistInputForm, ChecklistInputVehicleForm } from '@/models'

import { ChecklistTaskAnswer } from '../checklist-task-answer/checklist-task-answer'
import { formatChecklistInputType, getNestedFormCount } from '../checklists-task.page.utils'
import * as S from './checklist-input-form-row.styled'

interface ChecklistInputFormRowProps {
  input: ChecklistInputForm | ChecklistInputVehicleForm
}

type ChecklistFormItem = ChecklistInputForm['formItems'][number]

export const ChecklistInputFormRow = ({ input }: ChecklistInputFormRowProps) => {
  const { t } = useTranslation(['checklists'])
  const nestedFormCount = getNestedFormCount(input)

  if (nestedFormCount === 0) {
    return null
  }

  // Note: Spread the input.formItems and map over them to render the form items
  return (
    <>
      {Array.from({ length: nestedFormCount }).map((_, entryIndex) => (
        <React.Fragment key={entryIndex}>
          {entryIndex > 0 && <S.Divider />}
          {input.formItems.map((formItem: ChecklistFormItem) => {
            const answersForEntry = formItem.answers?.[entryIndex] ?? []

            const nestedInput = {
              // Note: Cast the formItem to ChecklistInput to access the answers property
              ...(formItem as unknown as ChecklistInput),
              answers: answersForEntry,
            }

            return (
              <S.Container key={`${formItem.id}-${entryIndex}`}>
                <S.Row>
                  <Typography as="span" size="text-small" weight="medium">
                    {formatChecklistInputType(formItem.inputType, t)}
                  </Typography>
                </S.Row>
                <S.Row>
                  <Typography as="span" size="text-small" weight="medium">
                    {formItem.taskLabel}
                  </Typography>
                </S.Row>
                <S.Row>
                  <Typography as="span" size="text-small">
                    <ChecklistTaskAnswer input={nestedInput} />
                  </Typography>
                </S.Row>
              </S.Container>
            )
          })}
        </React.Fragment>
      ))}
    </>
  )
}
